import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Switch } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as DragIcon } from "./assets/drag.svg";
import { ClientDefaultItem } from "../../../../types";

interface SortableItemProps {
  item: ClientDefaultItem;
  onVisibilityChange: (visible: boolean) => void;
}

export const SortableItem = ({
  item,
  onVisibilityChange,
}: SortableItemProps) => {
  const { t } = useTranslations();

  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="group grid min-w-fit grid-cols-[auto_100px] rounded-b-xl border-0 border-t border-solid border-[#EEF2F5] bg-white"
    >
      <div
        className="relative cursor-grab px-4 py-6 transition-colors group-hover:bg-grey-100"
        {...attributes}
        {...listeners}
      >
        <button
          type="button"
          className="absolute top-1/2 -left-6 flex h-6 w-6 -translate-y-1/2 transform cursor-grab touch-none items-center justify-center border-none bg-transparent opacity-0 transition-opacity group-hover:opacity-100"
        >
          <DragIcon />
        </button>

        <div className="flex items-center gap-2 font-medium text-dark">
          <svg
            width="28"
            height="28"
            viewBox="0 0 28 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1.25"
              y="1.25"
              width="25.5"
              height="25.5"
              rx="12.75"
              fill="#2196F3"
            />
            <rect
              x="1.25"
              y="1.25"
              width="25.5"
              height="25.5"
              rx="12.75"
              stroke="#fff"
              strokeWidth="1.5"
            />
            <path
              d="M9.188 10.934h9.625m-9.625 3.065h9.625m-9.625 3.066h4.124"
              stroke="#fff"
              strokeWidth="1.167"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          {item.name &&
            (typeof item.name === "string" ? item.name : t(item.name))}
        </div>
      </div>
      <div className="flex items-center justify-center border-0 border-l border-solid border-[#EEF2F5] px-4 py-3 transition-colors group-hover:bg-grey-100">
        <Switch
          isChecked={item.visible}
          onChange={(checked: boolean) => onVisibilityChange(checked)}
        />
      </div>
    </div>
  );
};
